export default {"src":"/_next/static/media/nest-logo-with-name.ee84fab0.svg","height":139,"width":420,"blurWidth":0,"blurHeight":0};